import { Box, Divider, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Typography, useTheme } from "@mui/material"
import './Expense.css';
import _ from "lodash";

//icon
import { FaCalculator } from "react-icons/fa";
import { useInitYearlyExpenses } from "./init/useExpenses";
import { numberFormatterLocale } from "view/Backend/IncomeExpenses/Ticket/fnTickit";
import DonutChartExpenses from "./Chart/DonutChart";
import StackExpenseChart from "./Chart/StackChart";
import { LastPage, FirstPage, KeyboardArrowRight, KeyboardArrowLeft } from "@mui/icons-material";
import { useState } from "react";

interface TablePaginationActionsProps {
    count: number;
    page: number;
    rowsPerPage: number;
    onPageChange: (
        event: React.MouseEvent<HTMLButtonElement>,
        newPage: number,
    ) => void;
}

function TablePaginationActions(props: TablePaginationActionsProps) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (
        event: React.MouseEvent<HTMLButtonElement>,
    ) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPage /> : <FirstPage />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPage /> : <LastPage />}
            </IconButton>
        </Box>
    );
}

const YearlyExpenses = ({ data, nYear }) => {

    const {
        arrColorListExpense,
        arrColorList,
        arrExpenseSummary,
        arrSectionPlan,
        arrSectionProject,
        arrExpense5,
        arrExpense5Line,
        arrExpense4,
        arrExpense4Line,
        arrExpenseFundItemActivity,
        lstYearTable
    } = useInitYearlyExpenses({ data });


    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - arrExpenseFundItemActivity.length) : 0;

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Grid container spacing={2} marginTop={2}>
            <Grid item md={1} xs={12}>
            </Grid>
            <Grid item md={10} xs={12} className="flex-center">
                <div className="box-topic-expense-yearly">
                    ข้อมูลรายจ่ายเงินกองทุนจัดการซากดึกดำบรรพ์ ปีบัญชี {parseInt(nYear) + 543}
                </div>
            </Grid>
            <Grid item xs={12} mt={2}>
                <Grid container spacing={2}>
                    {arrSectionPlan.map((m, i) => {
                        let nPercent = (m.nActual / m.nPlan) * 100;
                        if (isNaN(nPercent)) {
                            nPercent = 0;
                        }
                        return (
                            <Grid item xs={6} md={2.4} key={m.nID} className="mt-4">
                                <div className="rectangle-expense" style={{ backgroundColor: arrColorList[m.nOrder - 1] }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                            <Tooltip title={<span style={{ fontSize: "1rem" }}>{m.sDescription}</span>}>
                                                <div className="topic-section-yearly">
                                                    มาตรา<br />{m.sSectionShort}
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div style={{ padding: "0 16px" }}>
                                                <Grid container spacing={2} fontWeight={"bold"}>
                                                    <Grid item xs={12}>
                                                        รายจ่ายตามแผนงาน (บาท)
                                                    </Grid>
                                                    <Grid item xs={12} fontSize={"1.5rem"}>
                                                        {m.nPlan.toLocaleString('en-US', {
                                                            minimumFractionDigits: m.nPlan % 1 === 0 ? 0 : 2,
                                                            maximumFractionDigits: 2
                                                        })}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        รายจ่ายตามจริง (บาท)
                                                    </Grid>
                                                    <Grid item xs={12} fontSize={"1.5rem"}>
                                                        {m.nActual.toLocaleString('en-US', {
                                                            minimumFractionDigits: m.nActual % 1 === 0 ? 0 : 2,
                                                            maximumFractionDigits: 2
                                                        })}
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        </Grid>

                                    </Grid>
                                    <div className="circle-expense">
                                        <div style={{ textAlign: "center", lineHeight: "2rem" }}>
                                            <span>ร้อยละ</span>
                                            <p style={{ fontWeight: "bold", fontSize: "1.5rem", margin: 0 }}>
                                                {nPercent.toLocaleString('en-US', {
                                                    minimumFractionDigits: nPercent % 1 === 0 ? 0 : 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        )
                    })}

                </Grid>
            </Grid>
            <Grid item xs={12} mt={6}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6} display={"flex"} justifyContent={"left"} style={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
                        <div className="topic-yearly" style={{ background: "#78A3D4" }}>
                            ยอดทั้งหมด
                        </div>
                        <div className="card-container-expense" style={{ marginTop: "16px" }}>
                            <div id="div-text-expense">
                                <Grid container>
                                    <Grid className="h-auto" item sm={6} xs={12} display={"flex"} flexDirection={"column"} justifyContent={"center"}>
                                        <Typography className='title-text' sx={{ lineHeight: 1 }}>รายจ่ายตามแผนงาน (บาท)</Typography>
                                        <Typography className='value-text' sx={{ lineHeight: 1, fontSize: "2rem" }}>{numberFormatterLocale(data.nExpensePlan, 2)}</Typography>
                                    </Grid>
                                    <Grid className="h-auto" item sm={6} xs={12} display={"flex"} flexDirection={"column"} justifyContent={"center"}>
                                        <Typography className='title-text' sx={{ lineHeight: 1 }}>รายจ่ายตามจริง (บาท)</Typography>
                                        <Typography className='value-text' sx={{ lineHeight: 1, fontSize: "2rem" }}>{numberFormatterLocale(data.nExpenseActual, 2)}</Typography>
                                    </Grid>
                                </Grid>
                            </div>
                            <div id="main-icon">
                                <div id="div-icon" className="color-icon-1" style={{ flexDirection: "column", color: "#FFF" }}>
                                    <Typography sx={{ fontSize: "1.5rem" }}>ร้อยละ</Typography>
                                    <Typography sx={{ fontSize: "2rem", fontWeight: "bold" }}>{numberFormatterLocale((data.nExpenseActual / data.nExpensePlan) * 100, 2) ?? 0}</Typography>
                                </div>
                            </div>
                        </div>
                        {data.isRevisePlan &&
                            <Typography sx={{ color: "red", padding: "8px 48px", width: "100%", textAlign: "end" }}>ปรับแผนครั้งที่ {data.nRevisePlan} วันที่ {data.sRevisePlan} {data.sPlanDesc}</Typography>
                        }
                    </Grid>
                    <Grid item xs={12} md={6} display={"flex"} justifyContent={"left"} style={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
                        <div className="topic-yearly" style={{ background: "#EB4343" }}>
                            ค่าใช้จ่ายการบริหารกองทุนต่อค่าใช้จ่ายอุดหนุนโครงการ
                        </div>
                        <div className="box-section-cal">
                            <Grid container spacing={2}>
                                <Grid item xs={3} className="flex-center">
                                    <div className="expense-icon">
                                        <FaCalculator style={{ width: "60px", height: "60px", color: "#aa041d" }} />
                                    </div>
                                </Grid>
                                <Grid item xs={5} className="flex-center">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <div style={{ padding: "8px 0" }}>
                                                <Box fontSize={"2rem"} lineHeight={1}>{numberFormatterLocale(data.nExpenseItems, 2)}</Box>
                                                <Typography>40(5)</Typography>
                                            </div>
                                            <Divider sx={{ background: "#FFFFFF", borderColor: "#FFFFFF" }} />
                                            <div style={{ padding: "8px 0" }}>
                                                <Box fontSize={"2rem"} lineHeight={1}>{numberFormatterLocale(data.nExpenseProject, 2)}</Box>
                                                <Typography>40(1) - 40(4)</Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={4} className="flex-center">
                                    <Typography fontSize={"2rem"}>{data.nExpenseProject === 0 ? 0 : numberFormatterLocale((data.nExpenseItems / data.nExpenseProject) * 100, 2) ?? 0}%</Typography>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
                <div style={{ background: "#cae6ff", borderRadius: "20px" }}>
                    <Grid container spacing={2}>
                        {arrExpenseSummary.map((m, i) => {
                            return (
                                <Grid item xs={12} md={4} key={`expense_${m.nExpense}`}>
                                    <div style={{ padding: "24px" }}>
                                        <div className="rectangle-expense" style={{ display: "flex", alignItems: "center", height: "250px", background: "#f7f7f7" }}>
                                            <div className="topic-yearly box-budget" style={{ background: arrColorListExpense[i] }}>
                                                {m.sExpense}
                                            </div>
                                            <Grid item xs={12}>
                                                <div style={{ padding: "0 32px" }}>
                                                    <Grid container spacing={2} fontWeight={"bold"}>
                                                        <Grid item xs={12} color={"#646464"}>
                                                            รายจ่ายตามแผนงาน (บาท)
                                                        </Grid>
                                                        <Grid item xs={12} fontSize={"1.5rem"}>
                                                            <Box fontSize={"2rem"} lineHeight={1}>{numberFormatterLocale(m.nValue, 2)}</Box>
                                                        </Grid>
                                                        <Grid item xs={12} color={"#646464"}>
                                                            รายจ่ายตามจริง (บาท)
                                                        </Grid>
                                                        <Grid item xs={12} fontSize={"1.5rem"}>
                                                            <Box fontSize={"2rem"} lineHeight={1}>{numberFormatterLocale(m.nActual, 2)}</Box>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </Grid>
                                        </div>
                                    </div>
                                </Grid>
                            )
                        })}
                    </Grid>
                </div>
            </Grid>
            <Grid item xs={12} mt={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12} fontSize={"1.5rem"} fontWeight={"bold"}>
                        สัดส่วนค่าใช้จ่ายตามมาตรา 40
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            {arrSectionProject.map((m, i) => {
                                return (
                                    <Grid key={m.nID} item xs={12} md={6}>
                                        <DonutChartExpenses
                                            keys={m.nID}
                                            data={[...m.lstData]}
                                            title={m.sTitle}
                                        />
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12} fontSize={"1.5rem"} fontWeight={"bold"}>
                        ค่าใช้จ่าย 40(5) เทียบรายจ่ายปรับแผนงานกับรายจ่ายตามจริง
                    </Grid>
                    <Grid item xs={12}>
                        <StackExpenseChart
                            data={[...arrExpense5]}
                            xAxis={"sMonth"}
                            lstRenderLine={[...arrExpense5Line]}
                            sType={"40(5)"}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} mt={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12} fontSize={"1.5rem"} fontWeight={"bold"}>
                        ค่าใช้จ่าย 40(1) - 40(4) เทียบรายจ่ายปรับแผนงานกับรายจ่ายตามจริง
                    </Grid>
                    <Grid item xs={12}>
                        <StackExpenseChart
                            data={[...arrExpense4]}
                            xAxis={"sMonth"}
                            lstRenderLine={[...arrExpense4Line]}
                            sType={"40(3) - 40(4)"}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} mt={2}>
                <TableContainer id='table-pinned-dashboard' component={Paper}>
                    <Table sx={{ minWidth: 1000 }} >
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" padding='none' style={{ width: '100px' }}>ลำดับที่</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '115px' }}>กิจกรรมตามมาตรา</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '115px' }}>รายจ่ายปรับแผนงาน (บาท)</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '115px' }}>รายจ่ายตามจริง (บาท)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {[...arrSectionPlan].map((m, i) => {
                                return (
                                    <TableRow key={`section-plan-${i + 1}`} style={{ backgroundColor: "#f2f2f2" }}>
                                        <TableCell padding='none' align='center'>{i + 1}</TableCell>
                                        <TableCell padding='none'>{m.sSectionShort}</TableCell>
                                        <TableCell padding='none' align='right'>{numberFormatterLocale(m.nPlan, 2)}</TableCell>
                                        <TableCell padding='none' align='right'>{numberFormatterLocale(m.nActual, 2)}</TableCell>
                                    </TableRow>
                                )
                            })}
                            {[...arrSectionPlan].length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={4} align='center'>ไม่พบข้อมูล</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>

            <Grid item xs={12} mt={2}>
                <TableContainer id='table-pinned-dashboard' component={Paper}>
                    <Table sx={{ minWidth: 1000 }} >
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" padding='none' style={{ width: '100px' }}>ลำดับที่</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '115px' }}>รายการกิจกรรมมาตรา 40(5)</TableCell>
                                <TableCell component="th" padding='none' style={{ width: '100px' }}></TableCell>
                                {lstYearTable.map((m, i) => (
                                    <TableCell key={m + "tableYear"} component="th" padding='none' style={{ minWidth: '115px' }}>{m}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(rowsPerPage > 0
                                ? arrExpenseFundItemActivity.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : arrExpenseFundItemActivity).map((m, i) => {

                                    let nPage = page === 0 ? 1 : page;
                                    let nNo = ((nPage * rowsPerPage) + 1) - rowsPerPage;

                                    return (
                                        <>
                                            <TableRow style={{ backgroundColor: "#f2f2f2" }}>
                                                <TableCell padding='none' align='center'>{nNo + i}</TableCell>
                                                <TableCell padding='none'>{m.sExpense}</TableCell>
                                                <TableCell padding='none' align='center'>แผน</TableCell>
                                                {[...m.lstPlan].map((p, ip) => {
                                                    return (
                                                        <TableCell key={p.nYear + "plan"} padding='none' align='right'>{numberFormatterLocale(p.nValue, 2)}</TableCell>
                                                    )
                                                })}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell padding='none' align='center'></TableCell>
                                                <TableCell padding='none'></TableCell>
                                                <TableCell padding='none' align='center'>ผล</TableCell>
                                                {[...m.lstActual].map((a, ia) => {
                                                    return (
                                                        <TableCell key={a.nYear + "actual"} padding='none' align='right'>{numberFormatterLocale(a.nValue, 2)}</TableCell>
                                                    )
                                                })}
                                            </TableRow>
                                        </>
                                    )
                                })}

                            {emptyRows > 0 && (
                                <TableRow style={{ height: 53 * emptyRows }}>
                                    <TableCell colSpan={6} align='center'>ไม่พบข้อมูล</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                    colSpan={7}
                                    count={arrExpenseFundItemActivity.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        inputProps: {
                                            'aria-label': 'Rows per page',
                                        },
                                        native: true,
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    )
}

export default YearlyExpenses;
